module.exports = __webpack_public_path__ + "img/viewer_profile_gallery_wife.c4e47bf9.png";